/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Page = (props) => {
    let sizeClassName = 'c-page';
    switch (props.size) {
        case 'full':
            sizeClassName = 'c-page--full';
            break;
        case 'fullscreen':
            sizeClassName = 'c-page--fullscreen';
            break;
        default:
            sizeClassName = 'c-page';
    }
    const classNames = [
        'c-page',
        sizeClassName,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Page.propTypes = propTypes;

Page.defaultProps = defaultProps;

export default Page;
